import { throttle } from '@/shared/utils/timers';

import {
  ACTIVITY_EVENTS,
  ACTIVITY_EVENTS_THROTTLE,
  INACTIVITY_LIMIT,
  LAST_ACTIVITY_STORAGE_KEY,
  REFRESH_EVENT_KEY,
} from './constants';

export const userActivityChannel = new BroadcastChannel('user-inactivity');

export const onRefreshMessage = (event: MessageEvent) => {
  if (event.data === REFRESH_EVENT_KEY) {
    reloadWindow();
  }
};

const reloadWindow = () => {
  window.location.reload();
};

export const updateLastActivity = () => {
  localStorage.setItem(LAST_ACTIVITY_STORAGE_KEY, String(Date.now()));
};

export const checkInactivity = () => {
  const now = Date.now();

  const lastActivityString = localStorage.getItem(LAST_ACTIVITY_STORAGE_KEY);
  const lastActivity = lastActivityString ? Number(lastActivityString) : now;
  const diff = now - lastActivity;
  const shouldReload = diff > INACTIVITY_LIMIT;

  if (shouldReload) {
    userActivityChannel.postMessage(REFRESH_EVENT_KEY);

    reloadWindow();
  }
};

const onUserEvent = throttle(updateLastActivity, ACTIVITY_EVENTS_THROTTLE);

export const addUserActivityEventsListeners = (signal: AbortSignal) => {
  ACTIVITY_EVENTS.forEach((event) => {
    window.addEventListener(event, onUserEvent, { signal });
  });
};
